import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    padding: theme.spacing(1),
  },
  secure: {
    padding: theme.spacing(0, 5, 1.5),
    textAlign: 'center',
    color: theme.palette.grey.main,
  },
  lock: {
    maxHeight: theme.spacing(1.5),
    opacity: .7,
  },
  terms: {
    padding: theme.spacing(1),
  },
  info: {
    padding: theme.spacing(0, 5),
    fontSize: theme.spacing(1.25),
    textAlign: 'center',
    color: theme.palette.grey.main,
  }
}));

export default useStyles;
